import { css } from '@emotion/react';
import type { FC } from 'react';
import { loadingIcon } from './assets';
import type { LoadingProps } from './types';

export * from './types';

export const Loading: FC<LoadingProps> = (props) => {
  const { type = 'tail-spin', color = 'light', ...rest } = props;

  return (
    <img
      css={css`
        width: 100%;
        max-width: 100%;
      `}
      src={loadingIcon[color][type]}
      alt=""
      {...rest}
    />
  );
};
